import classes from "./PlayerItem.module.css";
import PlayerList from "./PlayerList";
import PlayerListEnhanced from "./PlayerListEnhanced";
import PlayerListMinimal from "./PlayerListMinimal";
import { useEffect, useState } from "react";
import { Card, CardContent, LinearProgress, Paper, Menu, MenuItem, IconButton, Typography } from "@mui/material";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { chukkerbookThemeTransparent } from "../../chukkerbbokTheme";
import { PRO_COLORS_MAP } from "src/pages/proColors";

function TeamItem(props) {
  const [handicap, setHandicap] = useState(0);
  const [isComputingHandicap, setIsComputingHandicap] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const numberPlayers = Object.keys(props.players).length;

  useEffect(() => {
    var newHandicap = 0;
    console.log("Recompute Handicap");
    Object.keys(props.players).forEach((key) => {
      if (props.useUSPARating) {
        newHandicap += props.players[key][6];
      } else {
        newHandicap += props.players[key][7];
      }
    });
    setHandicap(newHandicap);
    setIsComputingHandicap(false);
  }, [props.players, props.useUSPARating, numberPlayers]);

  const handleColorClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleColorClose = () => {
    setAnchorEl(null);
  };

  const handleColorSelect = (color) => {
    const teamId = props.id.split("_")[0];
    props.setChukkerDetails((prev) => ({
      ...prev,
      [props.chukkerId]: {
        ...prev[props.chukkerId],
        jersey_color: {
          ...prev[props.chukkerId]?.jersey_color,
          [teamId]: color
        }
      }
    }));
    handleColorClose();
  };

  return (
    <Paper elevation={0}>
      <Card
        sx={{
          mx: -2,
          boxShadow: props.minimalMode ? 0 : 1,
          backgroundColor: props.minimalMode
            ? "transparent"
            : props.isBench
            ? chukkerbookThemeTransparent["secondary"]
            : props.id.split("_")[0] === "A"
            ? chukkerbookThemeTransparent["warning"]
            : chukkerbookThemeTransparent["success"],
          borderRadius: props.minimalMode ? 0 : "8px",
        }}
      >
        <CardContent sx={{ p: props.minimalMode ? 0.5 : 1.5, "&:last-child": { pb: props.minimalMode ? 0.5 : 1.5 } }}>
          <Droppable
            droppableId={props.chukkerId + "____" + props.id}
            type="CHUKKER"
          >
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                <Draggable
                  draggableId={props.id}
                  isDragDisabled={props.managerMode !== -1 || true}
                  index={parseInt(
                    props.id.split("_")[1] === "A"
                      ? props.id.split("_")[1]
                      : 100 * props.id.split("_")[1]
                  )}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <Droppable
                        droppableId={props.chukkerId + "____" + props.id}
                        type="TEAM"
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                          >
                            {!isComputingHandicap && (
                              <div
                                className={classes.content}
                                data-testid={"handicap-" + props.id}
                                style={{ marginBottom: props.minimalMode ? "4px" : "8px" }}
                              >
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: 500,
                                    color: "text.secondary",
                                    fontSize: props.minimalMode ? "0.7rem" : "0.875rem",
                                  }}
                                >
                                  {props.id === "A_-1"
                                    ? "Bench"
                                    : "Team " + props.id.split("_")[0]}
                                  {props.managerMode !== -1 && !props.betaMode
                                    ? ""
                                    : ` • ${handicap}`}
                                </Typography>
                                {!props.minimalMode &&
                                  props.chukkerDetails &&
                                  props.chukkerDetails[props.chukkerId] &&
                                  props.chukkerDetails[props.chukkerId][
                                    "jersey_color"
                                  ] && (
                                    <>
                                      <IconButton
                                        onClick={handleColorClick}
                                        size="small"
                                      >
                                        <img
                                          src={
                                            PRO_COLORS_MAP[
                                              props.chukkerDetails[props.chukkerId][
                                                "jersey_color"
                                              ][props.id.split("_")[0]]
                                            ]
                                          }
                                          alt="Polo Pro Color"
                                          width={30}
                                          height={30}
                                          style={{
                                            display: "flex",
                                            marginRight: 8,
                                          }}
                                        />
                                      </IconButton>
                                      <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={handleColorClose}
                                      >
                                        {Object.keys(PRO_COLORS_MAP).map((color) => (
                                          <MenuItem
                                            key={color}
                                            onClick={() => handleColorSelect(color)}
                                          >
                                            <img
                                              src={PRO_COLORS_MAP[color]}
                                              alt={`${color} jersey`}
                                              width={30}
                                              height={30}
                                              style={{ marginRight: 8 }}
                                            />
                                            {color}
                                          </MenuItem>
                                        ))}
                                      </Menu>
                                    </>
                                  )}
                                {props.minimalMode ? (
                                  <PlayerListMinimal
                                    managerMode={props.managerMode}
                                    playerList={props.players}
                                    team={props.id}
                                    chukker={props.chukkerId}
                                    useUSPARating={props.useUSPARating}
                                    isBench={props.isBench}
                                    proColorMapping={props.proColorMapping}
                                    betaMode={props.betaMode}
                                  />
                                ) : props.useEnhancedPlayerList ? (
                                  <PlayerListEnhanced
                                    managerMode={props.managerMode}
                                    playerList={props.players}
                                    team={props.id}
                                    chukker={props.chukkerId}
                                    useUSPARating={props.useUSPARating}
                                    isBench={props.isBench}
                                    proColorMapping={props.proColorMapping}
                                    betaMode={props.betaMode}
                                    onQuickAssign={props.onQuickAssign}
                                    getAvailableTargets={props.getAvailableTargets}
                                  />
                                ) : (
                                  <PlayerList
                                    managerMode={props.managerMode}
                                    playerList={props.players}
                                    team={props.id}
                                    chukker={props.chukkerId}
                                    useUSPARating={props.useUSPARating}
                                    isBench={props.isBench}
                                    proColorMapping={props.proColorMapping}
                                    betaMode={props.betaMode}
                                  />
                                )}
                                {provided.placeholder}
                              </div>
                            )}
                            {isComputingHandicap && (
                              <LinearProgress color="secondary" />
                            )}
                          </div>
                        )}
                      </Droppable>
                    </div>
                  )}
                </Draggable>
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </CardContent>
      </Card>
    </Paper>
  );
}

export default TeamItem;
